import { InputBox } from "./style";

export const SearchBar = ({ placeholder }) => {
  return <InputBox placeholder={placeholder} />;
};
